import React from 'react';
import { useCustomContextualPermitted } from 'modules/audiences/hooks/useCustomContextualPermitted';
import AudienceTargetingSectionLegacy from 'modules/campaigns/modules/common-campaign-form/components/AudienceTargetingSectionLegacy/AudienceTargetingSectionLegacy';
import { AudienceTargetingSection } from './AudienceTargetingSection';
import { ContextualTargetingSection } from './ContextualTargetingSection';

export const AudienceTargetingSectionCampaignEditor = ({ isInitiallyCollapsed }) => {
    const isCustomContextualPermitted = useCustomContextualPermitted();

    if (isCustomContextualPermitted) {
        return (
            <>
                <ContextualTargetingSection isInitiallyCollapsed={isInitiallyCollapsed} />
                <AudienceTargetingSection isInitiallyCollapsed={isInitiallyCollapsed} />
            </>
        );
    }
    return <AudienceTargetingSectionLegacy isInitiallyCollapsed={isInitiallyCollapsed} />;
};
